import { jwtDecode } from "jwt-decode";

export const getCookie = (name) => {
  const value = `; ${document.cookie}`
  const parts = value.split(`; ${name}=`)
  if (parts.length === 2) {
    return parts.pop().split(';').shift()
  }
  return null
}

export const removeCookie = (name) => {
  document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`;
}

/**
 * Verifica se existe um token válido (não expirado) no cookie.
 * Retorna true se o token existe e não está expirado.
 */
export const hasValidToken = () => {
  const token = getCookie("token");
  if (!token) return false;

  try {
    const decoded = jwtDecode(token);
    if (!decoded.exp) return true;
    return decoded.exp * 1000 > Date.now();
  } catch {
    return false;
  }
}

/**
 * Limpa toda a sessão do usuário: cookie + localStorage.
 * Deve ser chamado ao fazer logout ou quando a sessão expira.
 */
export const clearSession = () => {
  removeCookie("token");
  localStorage.removeItem("__academetrics");
  localStorage.removeItem("__academetrics_shared_filters");
  localStorage.removeItem("__academetrics_date_range");
}
